export default __webpack_public_path__ + "static/media/netflix.0f51e252.png";